import React from "react";
import styled from "styled-components";

import { colors, device, fonts, fontWeights } from "../App/StyleVariables";

const SectionWrap = styled.section`
  text-align: center;
  padding: 1rem;

  @media ${device.sm} {
    text-align: left;
  }

  &:first-of-type {
    max-width: 100%;
    @media ${device.sm} {
      max-width: 58%;
    }
  }

  p {
    line-height: 1.2rem;
    margin-bottom: 1rem;
  }

  a {
    color: ${colors.white};
    margin-right: 0.8rem;

    &:hover {
      color: lighten(desaturate(${colors.white}, 10%), 10%);
    }

    &:active {
      color: darken(desaturate(${colors.white}, 10%), 10%);
    }
  }

  li {
    margin-bottom: 0.4rem;
  }
`;

const SectionHeading = styled.h3`
  font-family: ${fonts.brandon};
  font-weight: ${fontWeights.bold};
  font-size: 1rem;
  letter-spacing: 0.125rem;
  line-height: 1.5rem;
  margin-bottom: 0.75rem;
  text-transform: uppercase;
`;

export const IconGroup = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 5.625rem;

  @media ${device.sm} {
    margin: 0;
  }
`;

const Section = ({ header, children }) => (
  <SectionWrap>
    <SectionHeading children={header} />
    {children}
  </SectionWrap>
);

export default Section;
